<app-navbar></app-navbar>

<div class="container">
    <div class="news-info">
        <h3 class="terms-title">Wineincognito – незнакомец с силой сотни сомелье</h3>
        <div class="img-block">
            <img src="../../../../assets/img/news-info.png" alt="#">
        </div>
        <div class="news-content">
            <p class="subtitle">Причиной ее посещения стало вовсе не наличие на выставке довольно весомой «винной зоны»
                с дегустациями вина (кстати, за это респект организаторам!) — хотя разливали всем и были очень радушны.
                И совсем не присутствие нескольких павильонов винных поставщиков (что согласитесь, тоже здорово), а
                небольшая, мало кому пока известная программа — WineIncognito.
            </p>
            <p class="subtitle">
                Именно после прочтения краткого анонса о программе где-то в пучинах Интернета — я и поспешил
                зарегистрироваться и пойти «подивиться» на нее.
                Вместо обычного (как я думал) прослушивания анонса программы, «ваш покорный слуга» попал прямиком в
                самую гущу ее работы.
            </p>
            <p class="subtitle">
                В зале, за дюжиной столов, я обнаружил около 30 «мэтров» энологического рынка, проводящих «слепую»
                дегустацию около 300 вин, которые должны были составить начальную базу системы Wineinconito, чтобы затем
                — показать наглядно весь процесс начала до конца, так сказать, «в деле».
            </p>
            <p class="subtitle isTitle">
                Разработчики, правда, упомянули, что интерфейс программы еще дорабатывается, однако алгоритм анализа и
                выдачи информации — работает отлично!
            </p>
            <p class="subtitle">
                Среди присутствующих можно было видеть Артура Саркисяна, Евгения Богданова, Дениса Руденко, Александра
                Ставцева, Олега Осокина, Кирилла Мережко, Григория Чагадаева, Юрия Юдича, Кирилла Бурлуцкого, Сергея
                Оксиновского, Ирину Годунову, Анжелику Субботину, Виктора Сухорученкова.
            </p>
            <p class="subtitle">
                Также в зале присутствовали зарубежные гости — глава союза сомелье Грузии и владелец одной из крупных
                виноделен Греции.
                Идея специализированный экспертной системы по винам возникла 2015 года, когда проходила очередная
                крупная дегустация.
                Видя, как известные личности, дегустаторы «пыхтят» над записью своих впечатлений о винах, а затем
                сотрудники конкурса пытаются «вбить» эти заметки, да еще порой — с неподписанных анкет, и появилась
                мысль создать Wineincognito.
            </p>
            <p class="subtitle">
                За разработку программы взялся Алексей Соловьев (Президент Ассоциации кавистов России) со своей
                командой, а также известная в IT-индустрии компания AUVIX.
            </p>
        </div>
        <div class="share-block">
            <p class="share-text"><span>Дата:</span> 9 декабря 2021</p>
            <div class="share">
                <p class="share-text">Поделиться:</p>
                <i class="fab fa-vk"></i>
                <i class="fab fa-twitter"></i>
                <i class="fab fa-facebook-f"></i>
            </div>
        </div>
        <div class="carousel-block">
            <app-carousel></app-carousel>
        </div>
        <div class="cards-block">
            <h3 class="terms-title">Вина представленные на дегустации</h3>
            <div class="card-content">
                <cards-catalog></cards-catalog>
            </div>
            <div class="load-more">
                <h6 class="load-more-text">загрузить ещё </h6>
            </div>
        </div>
      
    </div>
</div>
<div class="banner">
    <div class="banner-search">
        <h3 class="search-title">Подпишитесь на нашу рассылку</h3>
        <p class="search-subtitle">и получайте новости, анонсы новых и прошедших конкурсов и дегустация по почте</p>
        <div class="search">
            <input class="search-inp" type="text" placeholder="Введите ваш e-mail, например yakovlev@yandex.ru">
            <button class="search-btn">
                <h4 class="btn-subtitle">Подписаться</h4>
            </button>
        </div>
    </div>
</div>

<app-footer></app-footer>